import jQuery from 'jquery';
// @ts-ignore
import scrollify from 'jquery-scrollify';
window.$ = jQuery;

scrollify({
  section: '.slide-wrapper',
  // sectionName: false,

  before:function(i,panels) {
    $(".pagination .active").removeClass("active");

    const videoSection = document.querySelector('.video-section');
    const j = videoSection ? i - 1 : i;

    if ((i === 0 && videoSection)) return;
    $(".pagination li").eq(j).find("a").addClass("active");
  },

  afterRender: function() {
    const ul = document.createElement("UL");

    ul.setAttribute("class", "pagination");
    ul.setAttribute("style", "z-index:997;");

    const videoSection = document.querySelector('.video-section');
    if (videoSection) {
      document.querySelector(".play-button").addEventListener("keyup", _handleKey);
      document.querySelector("video").addEventListener("keyup", _handleKey);
      function _handleKey(e) {
        if (e.key === "Tab") {
          scrollify.move("#1");
        }
      }
    }

    const imageSections = $(".image-section");
    imageSections.each(function(i) {
      const a = document.createElement("A");
      const j = videoSection ? i + 1 : i;
      const activeClass = (j) == scrollify.currentIndex() ? 'active' : '';
      const li = document.createElement("LI");

      const imageLink = this.querySelector("a");
      imageLink.addEventListener("keyup", function(e) {
        if (e.key === "Tab") {
          scrollify.move(`#${j + 1}`);
        }
      })
      const slideTitle = this.querySelector(".slide-overlay").innerHTML.trim();

      li.setAttribute("id", `${j + 1}`);
      a.setAttribute("href", `#${j + 1}`);
      a.setAttribute("class", `${activeClass}`);
      a.setAttribute("data-index", `${j}`);
      a.setAttribute("aria-label", `${slideTitle}`);
      a.style.setProperty('--imageSectionsLength', `${imageSections.length}`);
      a.addEventListener("click", function(e) {
        scrollify.move(j);
      });

      // key navigation for when Video Section is present
      if (videoSection) {
        // scrolls to image section pagination after tabbing out of video section
        a.addEventListener("keyup", function(e) {
          if (e.key === "Tab" && window.location.hash === "#1" || window.location.hash === "#content") {
            scrollify.next();
          }
        })
      }
      li.append(a);
      ul.append(li);
    });

    $('.images-section').before(ul);
  }
});
